/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendOpportunityResponse
 */
export interface SendOpportunityResponse {
    /**
     * 
     * @type {string}
     * @memberof SendOpportunityResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof SendOpportunityResponse
     */
    externalUrl?: string;
}

/**
 * Check if a given object implements the SendOpportunityResponse interface.
 */
export function instanceOfSendOpportunityResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function SendOpportunityResponseFromJSON(json: any): SendOpportunityResponse {
    return SendOpportunityResponseFromJSONTyped(json, false);
}

export function SendOpportunityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendOpportunityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
    };
}

export function SendOpportunityResponseToJSON(value?: SendOpportunityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'externalUrl': value.externalUrl,
    };
}

